import { render, staticRenderFns } from "./CardErrors.vue?vue&type=template&id=429e015a"
import script from "./CardErrors.vue?vue&type=script&lang=js"
export * from "./CardErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports